/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

@layer _, ah-skeleton;

@layer ah-skeleton {
	@keyframes pulse {
		0% {
			background-color: var(--ah-skl-gradient-1);
		}
		5% {
			background-color: var(--ah-skl-gradient-1);
		}
		45% {
			background-color: var(--ah-skl-gradient-2);
		}
		55% {
			background-color: var(--ah-skl-gradient-2);
		}
		95% {
			background-color: var(--ah-skl-gradient-1);
		}
		100% {
			background-color: var(--ah-skl-gradient-1);
		}
	}

	@keyframes wipe {
		0% {
			background-position: 100% 0;
		}
		100% {
			background-position: -100% 0;
		}
	}

	/* Effect */

	.effect-wipe {
		background: linear-gradient(
			90deg,
			var(--ah-skl-gradient-1) 60%,
			var(--ah-skl-gradient-2) 75%,
			var(--ah-skl-gradient-1) 90%
		);
		background-size: 200% 100%;
		animation: wipe 1.2s linear infinite;
	}

	.effect-pulse {
		background-color: var(--ah-skl-gradient-1);
		animation: pulse 1.2s linear infinite;
	}

	/* Theme */

	.theme-light {
		--ah-skl-layer-1: #ffffff;
		--ah-skl-layer-2: #f8f8f8;
		--ah-skl-gradient-1: #f3f3f3;
		--ah-skl-gradient-2: #e1e1e1;
	}

	.theme-dark {
		--ah-skl-layer-1: #111111;
		--ah-skl-layer-2: #1b1b1b;
		--ah-skl-gradient-1: #222222;
		--ah-skl-gradient-2: #323232;
	}

	/* Components */

	.heading > *:last-child:not(:first-child),
	.paragraph > *:last-child:not(:first-child),
	.caption > *:last-child:not(:first-child) {
		width: 86%;
	}

	.buttons--type-button,
	.buttons--type-action {
		> *:nth-child(5n + 2) {
			width: 105px;
		}

		> *:nth-child(5n + 3) {
			width: 92px;
		}

		> *:nth-child(5n + 4) {
			width: 110px;
		}

		> *:nth-child(5n + 5) {
			width: 94px;
		}
	}
}
